import { GraphQLFormattedError } from 'graphql'
import { client } from '../..'
import {
  ImportNationalContractReferenceInput,
  ImportSelectableNationalContractReferenceLevelsMutation,
  ImportSelectableNationalContractReferenceLevelsMutationVariables,
  UpdateNationalContractReferenceInput,
  UpdateSelectableNationalContractReferenceLevelsMutation,
  UpdateSelectableNationalContractReferenceLevelsMutationVariables,
} from '../../types'
import { IMPORT_SELECTABLE_NATIONAL_CONTRACT_REFERENCE_LEVELS, UPDATE_SELECTABLE_NATIONAL_CONTRACT_REFERENCE_LEVELS } from './Mutations'
import { GET_SELECTABLE_NATIONAL_CONTRACT_REFERENCES } from './Queries'

export const updateSelectableNationalContractReferenceLevels = async (
  input: UpdateNationalContractReferenceInput,
): Promise<{
  data: UpdateSelectableNationalContractReferenceLevelsMutation | null | undefined
  errors: readonly GraphQLFormattedError[] | undefined
}> => {
  const { data, errors } = await client.mutate<
    UpdateSelectableNationalContractReferenceLevelsMutation,
    UpdateSelectableNationalContractReferenceLevelsMutationVariables
  >({
    mutation: UPDATE_SELECTABLE_NATIONAL_CONTRACT_REFERENCE_LEVELS,
    variables: {
      input,
    },
    refetchQueries: [
      {
        query: GET_SELECTABLE_NATIONAL_CONTRACT_REFERENCES,
      },
    ],
    awaitRefetchQueries: true,
  })

  return { data, errors }
}

export const importSelectableNationalContractReferenceLevels = async (
  input: ImportNationalContractReferenceInput,
): Promise<{
  data: ImportSelectableNationalContractReferenceLevelsMutation | null | undefined
  errors: readonly GraphQLFormattedError[] | undefined
}> => {
  const { data, errors } = await client.mutate<
    ImportSelectableNationalContractReferenceLevelsMutation,
    ImportSelectableNationalContractReferenceLevelsMutationVariables
  >({
    mutation: IMPORT_SELECTABLE_NATIONAL_CONTRACT_REFERENCE_LEVELS,
    variables: {
      input,
    },
    refetchQueries: [
      {
        query: GET_SELECTABLE_NATIONAL_CONTRACT_REFERENCES,
      },
    ],
    awaitRefetchQueries: true,
  })

  return { data, errors }
}
